import React, { lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import Login from '../../pages/auth/Login';
import Logout from '../../pages/auth/Logout';
import NotFound from '../../pages/not_found/NotFound';
import Home from '../../pages/globalWrapper/GlobalWrapper';

// Admin Dashboard
const AdminPagesWarper = lazy(() => import('../../pages/admin/PagesWarper'));
const AdminHome = lazy(() => import('../../pages/admin/home/AdminHome'));
const ResetWorkShops = lazy(() => import('../../pages/admin/resetWorkShops/ResetWorkShops'));
const ExportData = lazy(() => import('../../pages/admin/exportData/ExportData'));
const ImportData = lazy(() => import('../../pages/admin/importData/ImportData'));

// ServeAsthma Room
const ServeAsthmaPagesWarper = lazy(() => import('../../pages/workshop/PagesWarper'));
const ServeAsthmaHome = lazy(() => import('../../pages/workshop/workshopHome/WorkshopHome'));
const WorkshopCore = lazy(() => import('../../pages/workshop/workshopCore/WorkshopCore'));

const Routes = () => {
  let currentPage = 'login';
  const strUser = localStorage.getItem('user');

  // 1. Determine the user's status based on localStorage
  if (!strUser) {
    currentPage = 'login';
  } else {
    // Optimization: Re-use the strUser variable instead of getting it from localStorage again
    const user = JSON.parse(strUser);
    if (user?.is_admin) {
      currentPage = 'admin';
    } else {
      currentPage = 'home';
    }
  }

  console.log('Current page status:', currentPage);

  return useRoutes([
    {
      path: '/',
      element: currentPage === 'login' ? <Navigate to="/login" replace /> : <Home />,
      children: [
        // FIX: Added index route. If the user visits exactly '/',
        // redirect them to their designated page ('/home' or '/admin')
        {
          index: true,
          element: <Navigate to={`/${currentPage}`} replace />,
        },
        {
          path: 'home',
          element:
            currentPage === 'home' ? (
              <ServeAsthmaPagesWarper />
            ) : (
              <Navigate to={`/${currentPage}`} replace />
            ),
          children: [
            { path: '', element: <ServeAsthmaHome /> },
            { path: 'workshop', element: <WorkshopCore /> },
          ],
        },
        {
          path: 'admin',
          element:
            currentPage === 'admin' ? (
              <AdminPagesWarper />
            ) : (
              <Navigate to={`/${currentPage}`} replace />
            ),
          children: [
            { path: '', element: <AdminHome /> },
            { path: 'reset', element: <ResetWorkShops /> },
            { path: 'export', element: <ExportData /> },
            { path: 'import', element: <ImportData /> },
          ],
        },
      ],
    },
    // 2. UPDATED ROUTE: If the user is on the login page but their status isn't 'login',
    // redirect them to their designated page (either /home or /admin).
    {
      path: '/login',
      element: currentPage === 'login' ? <Login /> : <Navigate to={`/${currentPage}`} replace />,
    },
    { path: '/logout', element: <Logout /> },
    { path: '*', element: <NotFound /> },
  ]);
};

export default Routes;
